// extracted by mini-css-extract-plugin
export var headingBase = "Heading-module--headingBase--82bf3";
export var headingBold = "Heading-module--headingBold--a0f54";
export var headingCenter = "Heading-module--headingCenter--d99d8";
export var headingH1 = "Heading-module--headingH1--93518";
export var headingH1Alt = "Heading-module--headingH1Alt--9b6f2";
export var headingH2 = "Heading-module--headingH2--28526";
export var headingH3 = "Heading-module--headingH3--be642";
export var headingH4 = "Heading-module--headingH4--4e9a4";
export var headingH5 = "Heading-module--headingH5--7fe07";
export var headingLeft = "Heading-module--headingLeft--c52e5";
export var headingNarrow = "Heading-module--headingNarrow--55eed";
export var headingNormal = "Heading-module--headingNormal--dd286";
export var headingRight = "Heading-module--headingRight--d8ab2";
export var headingUppercase = "Heading-module--headingUppercase--e3cdd";